<template>
    <div id="container" v-bind:style="{ background: 'url(' + image + ')' }">
        <a id="param" :href="new_ref" class="button btn-primary btn-experimente only-desktop">Experimente Grátis</a>

        <div id="inviteContainer">
            <div class="logoContainer">
                <img class="logo" src="@/assets/img/logo.png"/>
                <img class="text" src="@/assets/img/logo_2.png"/>
            </div>
            <div class="acceptContainer">
                <form class="custom-form" v-on:submit.prevent="onSubmit">
                    <h1>SEJA BEM VINDO!</h1>

                    <div class="formContainer">
                        <div class="formDiv" style="transition-delay: 0.2s;">
                            <p>CPF/CNPJ</p>
                            <input type="tel" id="cnpj" v-model="cnpj" v-mask="{mask: ['999.999.999-99', '99.999.999/9999-99' ]}" required="true"/>
                        </div>
                        <div class="formDiv" style="transition-delay: 0.4s;">
                            <p>SENHA</p>
                            <input type="password" v-model="password" required=""/>
                        </div>

                        <div class="error" v-bind:class="{ show: error}">
                            {{ errorMessage }}
                        </div>

                        <div class="formDiv" style="transition-delay: 0.6s;">
                            <button class="acceptBtn" type="submit">Entrar</button>
                            <span class="register">
                                <a style="font-size:12px;" :href="new_ref">Ainda não é cliente? Teste grátis</a>
                                <br>
                                <br>
                                <a :href="ref_site" target="_blank">© Yooga Tecnologia</a>
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <loading :active.sync="isLoading"
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</template>
<script>

import Loading from 'vue-loading-overlay';
import AuthService from '@/services/AuthService.js'
import ConfigService from '@/services/ConfigService.js'
import {http} from '@/services/HttpService'
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    data() {
        return {
            error: false,
            isLoading: false,
            cnpj: undefined,
            password: undefined,
            image: './acompanhar.jpg',
            errorMessage: "",
            new_ref: '',
            ref_site: '',

        }
    },
    components: {
        Loading
    },
    methods: {
        onSubmit(){
            this.isLoading = true
            this.error = false;

            AuthService.login({
                username: this.cnpj,
                password: this.password,
            }).then(res => {
                if(res.data.user.access_level === 200) {
                    throw(new Error())
                }

                if(res.data.type) {
                    localStorage.setItem("app_v3_token", res.data.token)
                    localStorage.setItem("app_user", JSON.stringify(res.data.user))

                    let user = res.data.user

                    user.nome = user.nome.replace("&", "e")
                    user.sobrenome = user.sobrenome ? user.sobrenome.replace("&", "e") : null
                    user.apelido = user.apelido ? user.apelido.replace("&", "e") : null

                    user.instalacao.apelido = user.instalacao.apelido ? user.instalacao.apelido.replace("&", "e") : null
                    user.instalacao.nome_fantasia = user.instalacao.nome_fantasia.replace("&", "e")
                    user.instalacao.razao_social = user.instalacao.razao_social.replace("&", "e")                    

                    let params = `?app_token=${res.data.token}&user=${JSON.stringify(user)}&unselectable=true`

                    window.location = process.env.VUE_APP_DASHBOARD_APP_URL + params
                } else {
                    window.accessLevel = res.data.user.access_level;
                    

                    Object.assign(http.defaults, { 
                        headers: { 
                            Authorization: 'bearer ' + res.data.token,
                            idi: res.data.user.current_idi
                        }
                    })

                    localStorage.setItem("token", res.data.token)
                    localStorage.setItem("user", JSON.stringify(res.data.user))
                    localStorage.setItem("stores", JSON.stringify(res.data.stores))
                    localStorage.setItem("stores_app", JSON.stringify(res.data.stores_app))
                    localStorage.setItem("current_idi", res.data.user.current_idi)

                    if(res.data.stores && res.data.stores.length) {
                        localStorage.setItem("ultima_sinc", moment(res.data.stores[0].ultima_conexao_ws).format("DD/MM/YY HH:mm:ss"))
                    }
                    
                    localStorage.removeItem("current_store")

                    if(window.accessLevel == 100) {
                        this.$router.replace('/fiscal')
                    } else {
                        this.$router.replace('/dashboard')
                    }

                }
            }).catch(err => {
                console.log(err)

                this.error = true
                this.isLoading = false

                if(err.response) {
                    this.errorMessage = "CPF/CNPJ incorreto ou senha inválida"
                } else {
                    this.errorMessage = "Verifique sua conexão e tente novamente"
                }
            })

        }
    },
    mounted() {
        // console.log(window.location.href);
        let url = window.location.href
        let param = url.split("?")
        if(param[1]){
            this.new_ref = "https://yooga.com.br/quero-yooga?"+param[1]
            this.ref_site = "https://yooga.com.br?"+param[1]
        }else{
            this.new_ref = "https://yooga.com.br/quero-yooga"
            this.ref_site = "https://yooga.com.br"
        }

        $(() => {
            setTimeout(() => {
                $('.logoContainer').transition({scale: 1}, 500, 'ease');
                setTimeout(() => {
                    $('.logoContainer .logo').addClass('loadIn');
                    setTimeout(() => {
                        $('.logoContainer .text').addClass('loadIn');
                        setTimeout(() => {
                            $('.logoContainer .desen').addClass('loadIn');
                            setTimeout(() => {
                                $('.acceptContainer').transition({height: '431.5px'});
                                setTimeout(() => {
                                    $('.logoContainer').addClass('mobile')
                                    $('.acceptContainer').addClass('loadIn');
                                    setTimeout(() => {
                                        $('.formDiv, form h1').addClass('loadIn');
                                        $('#cnpj').focus()
                                    }, 400)
                                }, 400)
                            }, 400)
                        }, 400)
                    }, 400)
                }, 750)
            }, 10)
        });        
    }
}
import $ from 'jquery.transit'
import moment from 'moment'

</script>
<style lang='scss'>
   @import url('https://fonts.googleapis.com/css?family=Poppins:400,600,700');
   

    .saiba {
        position: absolute;
        right: 25px;
        top: 15px;
    }

    .error {
        text-align: center;
        background-color: #fab1a0;
        color: #d63031;
        transition: all 0.4s ease;
        height: 0px;
        overflow: hidden;
    }
    .error.show {
        height: 30px;
        padding: 5px;
    }

    #container {
        height: 100vh;
        background-size: cover !important;
        background-position: center!important;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #inviteContainer {
        display: flex;
        overflow: hidden;
        position: relative;
        border-radius: 5px;
        .acceptContainer {
            padding: 45px 30px;
            box-sizing: border-box;
            width: 400px;
            margin-left: -400px;
            overflow: hidden;
            height: 0;
            opacity: 0;
            &.loadIn {
                opacity: 1;
                margin-left: 0;
                transition: 0.5s ease;
            }
            &:before {
                content: "";
                // background-size: cover !important;
                box-shadow: inset 0 0 0 3000px rgba(40,43,48,.75);
                filter: blur(10px);
                position: absolute;
                width: 150%;
                height: 150%;
                top: -50px;
                left: 242px;
            }
        }
    }
    .custom-form {
        position: relative;
        text-align: center;
        height: 100%;
        h1 {
            margin: 0 0 15px 0;
            font-family: 'Work Sans' !important;
            font-weight: 700;
            font-size: 20px;
            color: #fff;
            user-select: none;
            opacity: 0;
            left: -30px;
            position: relative;
            transition: 0.5s ease;
            &.loadIn {
                left: 0;
                opacity: 1;
            }
        }
    }
    .formContainer {
        text-align: left;
        .formDiv {
            margin-bottom: 30px;
            left: -25px;
            opacity: 0;
            transition: 0.5s ease;
            position: relative;
            &.loadIn {
                opacity: 1;
                left: 0;
            }
            &:last-child {
                padding-top: 10px;
                margin-bottom: 0;
            }
        }
        p {
            margin: 0;
            font-weight: 700;
            color: #aaa;
            font-size: 10px;
            user-select: none;
        }
        input[type=password], input[type=tel] {
            background: transparent;
            border: none;
            box-shadow: inset 0 -1px 0 rgba(255,255,255,0.15);
            padding: 15px 0;
            box-sizing: border-box;
            color: #fff;
            width: 100%;
            font-weight: 400;
            &:focus {
                box-shadow: inset 0 -2px 0 #fff;
            }
        }
    }
    .logoContainer {
        padding: 45px 35px;
        box-sizing: border-box;
        position: relative;
        z-index: 2;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transform: scale(0,0);
        img {
            width: 150px;
            margin-bottom: 0 px;
            display: block;
            position: relative;
            &:first-child {
                width: 150px;
            }
        }
        .text {
            width: 180px;
            padding: 95px 0 10px 0;
            margin-top: -70px;
            opacity: 0;
            &.loadIn {
                margin-top: 0;
                opacity: 1;
                transition: 0.8s ease;
            }
        }
        .logo {
            width: 100px !important;  
            position: relative;
            top: -20px;
            opacity: 0;
            &.loadIn {
                top: 0;
                opacity: 1;
                transition: 0.8s ease;
            }
        }
        &:before {
            content: "";
            // background-size: cover !important;
            position: absolute;
            top: -50px;
            left: -50px;
            width: 150%;
            height: 150%;
            filter: blur(10px);
            box-shadow: inset 0 0 0 3000px rgba(255,255,255,0.75);
        }
    }
    .forgotPas {
        color: #aaa;
        opacity: .8;
        text-decoration: none;
        font-weight: 700;
        font-size: 10px;
        margin-top: 15px;
        display: block;
        transition: 0.2s ease;
        &:hover {
            opacity: 1;
            color: #fff;
        }
    }
    .acceptBtn {
        width: 100%;
        box-sizing: border-box;
        background: #19a8e6;
        border: none;
        color: #fff;
        padding: 20px 0;
        border-radius: 3px;
        cursor: pointer;
        transition: 0.2s ease;
        user-select: none;
        &:hover {
            background: #6B7FC5;
        }
    }
    .register {
        color: #aaa;
        font-size: 11px;
        padding-top: 15px;
        display: block;
        text-align: center;
        a {
            color: #fff;
            text-decoration: none;
            box-shadow: inset 0 -2px 0 transparent;
            padding-bottom: 5px;
            user-select: none;
            &:hover {
                box-shadow: inset 0 -2px 0 #fff;
            }
        }
    }    
    @media (max-width: 416px) {
     .acceptContainer {

            &.loadIn {
                opacity: 1;
                margin-left: 0;
                transition: 0.5s ease;
                // margin-left: 20px !important;
                // margin-right: 20px !important;
                max-width: 270px !important;
            }
            // background-color: #5e5f63;
        }
    }

    @media (max-width: 800px) {
        .logoContainer.mobile {
           display: none;
        }

        .acceptContainer {
            // background-color: #5e5f63;
            &:before {
                content: "";
                // background-size: cover !important;
                box-shadow: inset 0 0 0 3000px rgba(40,43,48,.75);
                filter: blur(10px);
                position: absolute;
                width: 150%;
                height: 150%;
                top: -50px;
                left: -10px !important;
            }
        }

        .register {
            color: #aaa;
            padding-top: 15px;
            display: block;
            text-align: center;
            a {
                color: #fff;
                text-decoration: none;
                margin: 0 auto !important;
                box-shadow: inset 0 -2px 0 transparent;
                padding-bottom: 5px;
                user-select: none;
                &:hover {
                    box-shadow: inset 0 -2px 0 #fff;
                }
            }
        }    
    }

    .btn-experimente {
        background-color: #f45b93 !important; 
        color: white !important; 
        border: 3px solid #f45b93 !important; 
        margin-top: -10px !important; 
        margin-left: 0 !important;
        position: absolute;
        top: 25px;
        right: 25px;
        padding: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 5px;
        font-weight: bold !important;
        text-decoration: none !important;
    }

    .btn-experimente:hover {
        text-decoration: none !important;
    }

    @media (max-width: 400px) {
        .btn-experimente {
            display: none
        }
    }
</style>
